import { createErrorNotice, setLoading } from "./stripeHelpers"

export default function () {
  const setupForm = document.getElementById("js-tenant-bank-account-setup-intent-form")
  const paymentEle = document.getElementById("payment-element")
  if (!setupForm || !paymentEle) return

  const clientSecret = setupForm.dataset.stripeClientSecret
  const stripeAccount = setupForm.dataset.stripeAccountId
  const stripe = Stripe(setupForm.dataset.stripePublicKey, {
    stripeAccount,
  })

  const elements = stripe.elements({ clientSecret })

  const paymentElement = elements.create("payment", {
    paymentMethodOrder: ["us_bank_account"],
    layout: "tabs",
    fields: { billingDetails: { name: "never" } },
  })

  paymentElement.mount("#payment-element")

  setupForm.addEventListener("submit", async function (event) {
    event.preventDefault()
    setLoading(true)

    const accountHolderName = document.getElementById("account-holder-name-input").value

    const { error } = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: setupForm.dataset.returnUrl,
        payment_method_data: {
          billing_details: { name: accountHolderName },
        },
      },
    })

    if (error) {
      createErrorNotice(error.message || "An unexpected error occurred.")
    }

    setLoading(false)
  })
}
